export default __webpack_public_path__ + "static/media/four.c450b943.svg";